import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { ListingSignMovementCreateForm, TListingSignMovementCreateFormCodec } from "../form/ListingSignMovementCreateForm";
import { ListingDataFormIO, TListingDataFormIOCodec } from "../formIO/ListingDataFormIO";
import { NewListingAdHocTaskFormIO, TNewListingAdHocTaskFormIOCodec } from "../formIO/NewListingAdHocTaskFormIO";
import { ListingValuationFormIO, TListingValuationFormIOCodec } from "../formIO/ListingValuationFormIO";
import { ListingValSubmitFormIO, TListingValSubmitFormIOCodec } from "../formIO/ListingValSubmitFormIO";
import { ListingPnlFormIO, TListingPnlFormIOCodec } from "../formIO/ListingPnlFormIO";
import { ListingValuationTabFormIO, TListingValuationTabFormIOCodec } from "../formIO/ListingValuationTabFormIO";
import { ListingRoadblockDetailForm, ListingRoadblocksForm, TListingRoadblockDetailFormCodec, TListingRoadblocksFormCodec } from "../form/ListingRoadblockForm";
import { ListingValuationActionFormIO, TListingValuationActionFormIOCodec } from "../formIO/ListingValuationActionFormIO";

export const ListingPagePartial: TRequiredCodec<{
    data: TListingDataFormIOCodec;
    create_sign_movement: TListingSignMovementCreateFormCodec;
    create_ad_hoc_task: TNewListingAdHocTaskFormIOCodec;
    listing_valuation: TListingValuationFormIOCodec;
    listing_val_submit: TListingValSubmitFormIOCodec;
    listing_pnl: TListingPnlFormIOCodec;
    valuation_tab: TListingValuationTabFormIOCodec;
    roadblocks: TListingRoadblocksFormCodec;
    open_roadblock: TListingRoadblockDetailFormCodec;
    valuation_action: TListingValuationActionFormIOCodec;
}> = required({
    data: ListingDataFormIO,
    create_sign_movement: ListingSignMovementCreateForm,
    create_ad_hoc_task: NewListingAdHocTaskFormIO,
    listing_valuation: ListingValuationFormIO,
    listing_val_submit: ListingValSubmitFormIO,
    listing_pnl: ListingPnlFormIO,
    valuation_tab: ListingValuationTabFormIO,
    roadblocks: ListingRoadblocksForm,
    open_roadblock: ListingRoadblockDetailForm,
    valuation_action: ListingValuationActionFormIO,
});

export type TListingPagePartialCodec = typeof ListingPagePartial;
